import React from 'react';
import { EditableInfo } from '@icoach/components';

const AgreedNotesBox = ({ className, hasSMS, onEdit }) => {
    return (
        <EditableInfo label="簡訊通知" onEdit={onEdit} className={className} isEdit>
            {hasSMS ? '開啟' : '關閉'}
        </EditableInfo>
    );
};

export default AgreedNotesBox;
